import { Grid2, Stack } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import PageHeader from "../components/PageHeader";
import BranchRegister from "../components/BranchRegister";
import { branchList } from "../services/branches";
import BranchesTableComponent from "../components/BranchesTableComponent";

const Branches = () => {
  const [open, setOpen] = useState(false);
  const {
    data,
    isLoading,
    isFetching,
    refetch,
  }: {
    data: Array<{
      id: string;
      name: string;
      document: string;
      status: string;
      createdAt: string | Date;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["branchList"],
    queryFn: async () => await branchList(),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Minhas Filiais"
          subtitle="Informações gerais das suas filiais."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              {/* <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconBuilding size={18} />
                <Typography variant="body2">Cadastrar filial</Typography>
              </Button> */}
            </Stack>
          }
        />

        <Grid2 size={12}>
          <BranchesTableComponent data={data} refetch={() => refetchAll()} />
        </Grid2>
      </Grid2>
      <BranchRegister
        open={open}
        onClose={() => setOpen(false)}
        refetch={() => refetchAll()}
      />
    </ContainerLoading>
  );
};

export default Branches;
